var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMailru(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#168DE2",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.63 11.913c-.108-2.095-1.66-3.355-3.534-3.355h-.07c-2.164 0-3.363 1.705-3.363 3.641 0 2.168 1.45 3.537 3.354 3.537 2.121 0 3.516-1.557 3.617-3.4l-.005-.423zm-3.594-5.23c1.445 0 2.804.64 3.801 1.643v.004c0-.481.323-.844.772-.844h.113c.702 0 .846.665.846.875l.003 7.482c-.05.49.505.743.812.428 1.199-1.234 2.633-6.347-.745-9.308-3.148-2.762-7.373-2.307-9.62-.755-2.388 1.65-3.916 5.305-2.431 8.736 1.618 3.743 6.248 4.86 9 3.746 1.394-.564 2.038 1.324.59 1.941-2.186.933-8.273.84-11.117-4.097C2.14 13.2 2.241 7.336 7.337 4.298c3.897-2.325 9.036-1.682 12.135 1.562 3.24 3.39 3.05 9.74-.109 12.208-1.431 1.122-3.558.03-3.544-1.604l-.015-.534a5.312 5.312 0 01-3.768 1.57c-2.856 0-5.368-2.518-5.368-5.38 0-2.89 2.512-5.437 5.368-5.437z"
  }))));
}

export default SvgMailru;